import { Component, ErrorInfo, ReactNode } from 'react';

type Props = { children: ReactNode; label?: string };
type State = { error: Error | null };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', this.props.label ?? '', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="card" style={{ background: '#FBECE5', borderColor: '#E07A5F' }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>
            ⚠ Une erreur est survenue {this.props.label ? `dans ${this.props.label}` : ''}
          </div>
          <div className="card-meta" style={{ fontSize: 12, marginBottom: 10 }}>
            {this.state.error.message}
          </div>
          <button
            className="btn btn-ghost"
            onClick={() => this.setState({ error: null })}
            style={{ padding: '4px 12px', fontSize: 12 }}
          >
            Réessayer
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
